var _g, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVeryConfident(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 72",
    height: "8em",
    width: "8em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "strokeElem",
    stroke: "#00b5ed",
    strokeWidth: 1,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M30.8,53.4c-4.5-1.4-6.8-4.8-6.8-8.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "strokeElem",
    stroke: "#00b5ed",
    strokeWidth: 1,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M48,44.6c0,4-2.2,7.3-6.7,8.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "strokeElem",
    stroke: "#00b5ed",
    strokeWidth: 1,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M48,45.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "strokeElem",
    stroke: "#00b5ed",
    strokeWidth: 1,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M24.1,45.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "strokeElem",
    stroke: "#00b5ed",
    strokeWidth: 1,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M20.3,27.1c0.7-1.4,1.9-2.5,3.4-3c1.4-0.7,3-0.8,4.5-0.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "strokeElem",
    stroke: "#00b5ed",
    strokeWidth: 1,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M50.9,27.1c-1.6-2.8-4.8-4.2-7.9-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "strokeElem",
    stroke: "#00b5ed",
    strokeWidth: 1,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M44.3,57.3C52.9,54,59,45.6,59,35.9c0-12.7-10.3-23-23-23c-12.7,0-23,10.3-23,23c0,9.8,6.1,18.2,14.7,21.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "strokeElem",
    stroke: "#00b5ed",
    strokeWidth: 1,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M20.3,27.1c0.7-1.4,1.9-2.5,3.4-3c1.4-0.7,3-0.8,4.5-0.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "strokeElem",
    stroke: "#00b5ed",
    strokeWidth: 1,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M50.9,27.1c-1.6-2.8-4.8-4.2-7.9-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "strokeElem",
    stroke: "#00b5ed",
    strokeWidth: 1,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M40.5,49.2c0,0,1.5,8.8-1.1,10.9l0,0c-3.8,3.4-7.1-0.1-7,0c-2.6-2.1-1.1-10.9-1.1-10.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "strokeElem",
    stroke: "#00b5ed",
    strokeWidth: 1,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M24.1,44.6c0,0,12.1,3.1,23.7,0.1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "strokeElem otherStrokeElem",
    stroke: "#5cb85c",
    strokeWidth: 1,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M29.2,31.4c-0.2-0.7-1-1.3-2-1.3h0c-1.1,0-2,0.7-2,1.6c0,0.9,0.9,1.6,2,1.6l0,0c1.1,0,2,0.7,2,1.6s-0.9,1.6-2,1.6l0,0c-1,0-1.8-0.5-2-1.3"
  }), /*#__PURE__*/React.createElement("line", {
    className: "strokeElem otherStrokeElem",
    stroke: "#5cb85c",
    strokeWidth: 1,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 27.3,
    y1: 30.2,
    x2: 27.3,
    y2: 28.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "strokeElem otherStrokeElem",
    stroke: "#5cb85c",
    strokeWidth: 1,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 27.3,
    y1: 38,
    x2: 27.3,
    y2: 36.5
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "strokeElem otherStrokeElem",
    stroke: "#5cb85c",
    strokeWidth: 1,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M46.3,31.4c-0.2-0.7-1-1.3-2-1.3h0c-1.1,0-2,0.7-2,1.6c0,0.9,0.9,1.6,2,1.6l0,0c1.1,0,2,0.7,2,1.6s-0.9,1.6-2,1.6l0,0c-1,0-1.8-0.5-2-1.3"
  }), /*#__PURE__*/React.createElement("line", {
    className: "strokeElem otherStrokeElem",
    stroke: "#5cb85c",
    strokeWidth: 1,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 44.3,
    y1: 30.2,
    x2: 44.3,
    y2: 28.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "strokeElem otherStrokeElem",
    stroke: "#5cb85c",
    strokeWidth: 1,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 44.3,
    y1: 38,
    x2: 44.3,
    y2: 36.5
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "strokeElem otherStrokeElem",
    stroke: "#5cb85c",
    strokeWidth: 1,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M37.9,53c-0.2-0.7-1-1.3-2-1.3h0c-1.1,0-2,0.7-2,1.6s0.9,1.6,2,1.6l0,0c1.1,0,2,0.7,2,1.6s-0.9,1.6-2,1.6l0,0c-1,0-1.8-0.5-2-1.3"
  }), /*#__PURE__*/React.createElement("line", {
    className: "strokeElem otherStrokeElem",
    stroke: "#5cb85c",
    strokeWidth: 1,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 35.9,
    y1: 51.7,
    x2: 35.9,
    y2: 50.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "strokeElem otherStrokeElem",
    stroke: "#5cb85c",
    strokeWidth: 1,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 35.9,
    y1: 59.6,
    x2: 35.9,
    y2: 58.1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeryConfident);
export default __webpack_public_path__ + "static/media/very-confident.333af8d9.svg";
export { ForwardRef as ReactComponent };